import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue, useResetRecoilState } from 'recoil';
import {
  Button,
  Grid,
  Modal,
  ModalContent,
  ModalFooter,
  ModalOverlay,
} from '@tq/ui-components';
import { useIsMobile } from '@tq/ui-components/dist/hooks';

import { MobileModal } from 'components';
import { useNavigate } from 'hooks';
import { openReportModalState, reportState } from 'store';
import { ReportModalContentSwitch } from '..';

export const ReportModal: React.FC = () => {
  const { t } = useTranslation('report_modal');

  const report = useRecoilValue(reportState);
  const isMobile = useIsMobile();
  const { navigateToReport } = useNavigate();

  const isOpen = useRecoilValue(openReportModalState);
  const resetIsOpen = useResetRecoilState(openReportModalState);

  const handleClose = () => resetIsOpen();

  const handleSubmit = () => {
    if (report) {
      resetIsOpen();
      navigateToReport(report.name);
    }
  };

  return isMobile ? (
    <MobileModal isOpen={isOpen} onClose={handleClose}>
      {report && <ReportModalContentSwitch handleSubmit={handleSubmit} report={report} />}
      <ModalFooter>
        <Grid gridGap={4} w='100%'>
          <Button isFullWidth type='submit' form='report-dates-form'>
            {t('run_report_button_text', 'Run report')}
          </Button>
          <Button isFullWidth variant='tertiary' onClick={handleClose}>
            {t('cancel_button_text', 'Cancel')}
          </Button>
        </Grid>
      </ModalFooter>
    </MobileModal>
  ) : (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        {report && <ReportModalContentSwitch handleSubmit={handleSubmit} report={report} />}

        <ModalFooter justifyContent='end'>
          <Grid gridAutoFlow='column' gridGap={4}>
            <Button variant='tertiary' onClick={handleClose}>
              {t('cancel_button_text', 'Cancel')}
            </Button>
            <Button type='submit' form='report-dates-form'>
              {t('run_report_button_text', 'Run report')}
            </Button>
          </Grid>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
